import MaestroLogo from '@tradera/blueprint/theme/logos/maestro_vertical.svg?next-image';
import MasterCardLogo from '@tradera/blueprint/theme/logos/mastercard_vertical.svg?next-image';
import PaynovaLogo from '@tradera/blueprint/theme/logos/paynova.svg?next-image';
import PaypalLogo from '@tradera/blueprint/theme/logos/paypal.svg?next-image';
import SwishLogo from '@tradera/blueprint/theme/logos/swish_horizontal.svg?next-image';
import VisaLogo from '@tradera/blueprint/theme/logos/visa.svg?next-image';
import GooglePayLogo from '@tradera/blueprint/theme/logos/google-pay.svg?next-image';
import ApplePayLogo from '@tradera/blueprint/theme/logos/apple-pay.svg?next-image';
import KlarnaLogo from '@tradera/blueprint/theme/logos/klarna.svg?next-image';
import TrustlyLogo from '@tradera/blueprint/theme/logos/trustly.svg?next-image';
import TraderaLogo from '@tradera/blueprint/theme/logos/tradera_new.svg?next-image';

import styles from './payment-method-logo.module.scss';

type PaymentMethodLogoProps = {
    paymentMethod: string;
    displayText?: string;
};

const PaymentMethodLogo = ({
    paymentMethod,
    displayText,
}: PaymentMethodLogoProps) => {
    const visaLogo = (
        <div
            key={paymentMethod}
            className={`${styles.logoWithBorder} ${styles.narrow}`}
            style={{ padding: '6px' }}
            title={displayText}>
            <img src={VisaLogo} loading="lazy" alt={displayText} />
        </div>
    );
    const mastercardLogo = (
        <div
            key={paymentMethod}
            className={`${styles.logoWithBorder} ${styles.narrow} justify-content-center`}
            style={{ padding: '3px' }}
            title={displayText}>
            <img
                src={MaestroLogo}
                loading="lazy"
                alt={displayText}
                className={styles.logoDouble}
            />
            <img
                src={MasterCardLogo}
                loading="lazy"
                alt={displayText}
                className={styles.logoDouble}
            />
        </div>
    );
    switch (paymentMethod) {
        case 'Visa':
            return visaLogo;
        case 'Mastercard':
            return mastercardLogo;
        case 'VisaMasterCard':
            return (
                <div key={paymentMethod} className="d-flex">
                    <div style={{ marginRight: '2px' }}>{visaLogo}</div>
                    {mastercardLogo}
                </div>
            );
        case 'Paynova':
            return (
                <div
                    key={paymentMethod}
                    className={styles.logoWithBorder}
                    title={displayText}>
                    <img src={PaynovaLogo} loading="lazy" alt={displayText} />
                </div>
            );
        case 'PayPal':
            return (
                <div
                    key={paymentMethod}
                    className={styles.logoWithBorder}
                    title={displayText}>
                    <img src={PaypalLogo} loading="lazy" alt={displayText} />
                </div>
            );
        case 'SwishHandel':
            return (
                <div
                    key={paymentMethod}
                    className={styles.logoWithBorder}
                    title={displayText}>
                    <img src={SwishLogo} loading="lazy" alt={displayText} />
                </div>
            );
        case 'ApplePay':
            return (
                <img
                    src={ApplePayLogo}
                    loading="lazy"
                    key={paymentMethod}
                    className={styles.logoWithoutBorder}
                    alt={displayText}
                />
            );
        case 'GooglePay':
            return (
                <img
                    src={GooglePayLogo}
                    loading="lazy"
                    key={paymentMethod}
                    className={styles.logoWithoutBorder}
                    alt={displayText}
                />
            );
        case 'Klarna':
            return (
                <img
                    src={KlarnaLogo}
                    loading="lazy"
                    key={paymentMethod}
                    className={styles.logoWithoutBorder}
                    alt={displayText}
                />
            );
        case 'Trustly':
            return (
                <img
                    src={TrustlyLogo}
                    loading="lazy"
                    key={paymentMethod}
                    className={styles.logoWithBorder}
                    alt={displayText}
                    style={{ padding: '5px 5px 3px 5px' }}
                />
            );
        case 'Invoice':
        case 'Wallet':
            return (
                <img
                    src={TraderaLogo}
                    loading="lazy"
                    key={paymentMethod}
                    className={styles.logoWithBorder}
                    alt={displayText}
                />
            );
        default:
            return null;
    }
};

export default PaymentMethodLogo;
